// extracted by mini-css-extract-plugin
export default {"loader-backdrop":"Loader_loader-backdrop__gbtzE","loader":"Loader_loader__DwtSp","block":"Loader_block__Q9wUD","wave":"Loader_wave__NcEY5"};